'use client';

import { createContext } from 'react';

import { useSearchValuesForm } from 'hooks/useSearchValuesForm';

const SearchValuesContext = createContext();

export const SearchValuesProvider = ({ children }) => {
  const searchParams = useSearchValuesForm();

  return <SearchValuesContext.Provider value={searchParams}>{children}</SearchValuesContext.Provider>;
};

export { SearchValuesContext };
